/* @ngInject */
const emailRequest = (
  $q,
  emailResource,
  errorHandler,
  valueHandler,
  labels
) => {
  const self = {}

  self.delete = async (_id) => {
    return $q((resolve, reject) => {
      const functionName = '$email.delete'
      emailResource.delete({ action: _id, }, (res) => {
        if (res && res.success) {
          resolve(labels.email.log.delete.success)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, _id)
          reject(labels.email.log.delete.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  return self
}

export default emailRequest



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/email/services/request.service.js